var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHundred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_13657_36345)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13657_36345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13657_36345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13657_36345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 33.3359H36C36.3777 33.3359 36.6944 33.2082 36.95 32.9526C37.2055 32.697 37.3333 32.3804 37.3333 32.0026V24.0026C37.3333 23.6248 37.2055 23.3082 36.95 23.0526C36.6944 22.797 36.3777 22.6693 36 22.6693H32C31.6222 22.6693 31.3055 22.797 31.05 23.0526C30.7944 23.3082 30.6666 23.6248 30.6666 24.0026V32.0026C30.6666 32.3804 30.7944 32.697 31.05 32.9526C31.3055 33.2082 31.6222 33.3359 32 33.3359ZM33.3333 30.6693V25.3359H34.6666V30.6693H33.3333ZM24 33.3359H28C28.3777 33.3359 28.6944 33.2082 28.95 32.9526C29.2055 32.697 29.3333 32.3804 29.3333 32.0026V24.0026C29.3333 23.6248 29.2055 23.3082 28.95 23.0526C28.6944 22.797 28.3777 22.6693 28 22.6693H24C23.6222 22.6693 23.3055 22.797 23.05 23.0526C22.7944 23.3082 22.6666 23.6248 22.6666 24.0026V32.0026C22.6666 32.3804 22.7944 32.697 23.05 32.9526C23.3055 33.2082 23.6222 33.3359 24 33.3359ZM25.3333 30.6693V25.3359H26.6666V30.6693H25.3333ZM21.3333 32.0026V24.0026C21.3333 23.6248 21.2055 23.3082 20.95 23.0526C20.6944 22.797 20.3777 22.6693 20 22.6693C19.6222 22.6693 19.3055 22.797 19.05 23.0526C18.7944 23.3082 18.6666 23.6248 18.6666 24.0026V32.0026C18.6666 32.3804 18.7944 32.697 19.05 32.9526C19.3055 33.2082 19.6222 33.3359 20 33.3359C20.3777 33.3359 20.6944 33.2082 20.95 32.9526C21.2055 32.697 21.3333 32.3804 21.3333 32.0026ZM14.6666 36.0026V20.0026C14.6666 19.2693 14.9277 18.6415 15.45 18.1193C15.9722 17.597 16.6 17.3359 17.3333 17.3359H38.6666C39.4 17.3359 40.0277 17.597 40.55 18.1193C41.0722 18.6415 41.3333 19.2693 41.3333 20.0026V36.0026C41.3333 36.7359 41.0722 37.3637 40.55 37.8859C40.0277 38.4082 39.4 38.6693 38.6666 38.6693H17.3333C16.6 38.6693 15.9722 38.4082 15.45 37.8859C14.9277 37.3637 14.6666 36.7359 14.6666 36.0026Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13657_36345",
    x: 8.66663,
    y: 13.3359,
    width: 38.6666,
    height: 33.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0 0 0 0 0 0.588235 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13657_36345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13657_36345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13657_36345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1666 16) rotate(48.9452) scale(61.6644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B940FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#300096"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHundred);
export default __webpack_public_path__ + "static/media/hundred.e19b24dce6205a56c1e1b45181f92adf.svg";
export { ForwardRef as ReactComponent };